import Repository from '../repository';

const resource = '/setting';

export default {
  get(params) {
    return Repository.get(`${resource}`, { params });
  },
};
